$(function () {

    const header = $("#header");
    const categories = $(".sidebar")
    const categoriesImage = $(".sidebar__contact")
    const pageSelector = $(".page");
    const headerInitialHeight = $("#header").not('.fixed').innerHeight();
    

    $(window).on("scroll", function (event) {
        let scrollPos = $(window).scrollTop();
        let headerH = $("#header").not('.fixed').innerHeight();

        

        let pageIndent = headerInitialHeight;

        if (headerH != headerInitialHeight) {
            pageIndent = headerH;
        }

        if (scrollPos > headerInitialHeight) {
            const headercompressedHeight = $("#header").innerHeight();
            pageSelector.css('paddingTop', pageIndent);
            header.addClass("fixed");
            //stick filters and hide image
            categories.addClass(`sticky`);
            categories.css('top', headercompressedHeight)
            categoriesImage.addClass("hidden");
        } else {
            pageSelector.css('paddingTop', 0);
            header.removeClass("fixed");
            //revert
            categories.removeClass("sticky");
            categories.css('top', 0);
            categoriesImage.removeClass("hidden");
        }
    });

    const searchToggle = $("#searchToggle");
    const search = $("#headerSearch");

    searchToggle.on("click", () => {
        if (!search.hasClass('opened')) {
            search.addClass("opened");
        } else {
            search.removeClass("opened");
        }
    });
});